import { connect, MapStateToProps } from "react-redux";

import {
    getActionExtendedProperties,
    getActionIconCode,
    getActionLocKey,
    getActionVisibility,
} from "@multiweb/reactCore/datasource";
import { getPrimaryText, getSecondaryText } from "@multiweb/reactCore/i18n";
import { ExtendedPropertiesType } from "@multiweb/types/multiweb";
import { IAppState } from "@multiweb/types/react";
import { getInteractive } from "../../selectors";
import { RowActionComponent, RowActionComponentProps } from "../RowActionComponent";

export type RowActionProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
    /** Identifikátor řádku, na kterém se akce nachází. */
    recordId: string;
    /** Identifikátor akce, která se má zobrazit. */
    actionId: string;
    /** Určuje, zda jsou akce zakázány. */
    disabled?: boolean;
    /** Vlastnosti akce */
    extendedProperties?: ExtendedPropertiesType;
};

type StateProps = Pick<RowActionComponentProps, "actionText" | "visible" | "actionTitle" | "iconCode" | "interactive">;

const mapStateToProps: MapStateToProps<StateProps, RowActionProps, IAppState> = (
    state,
    { dataSourceKey, actionId },
) => ({
    iconCode: getActionIconCode(state, { dataSourceKey, actionId }),
    visible: getActionVisibility(state, { dataSourceKey, actionId }),
    actionText: getPrimaryText(state, getActionLocKey(state, { dataSourceKey, actionId }) || ""),
    actionTitle: getSecondaryText(state, getActionLocKey(state, { dataSourceKey, actionId }) || ""),
    interactive: getInteractive(state, dataSourceKey),
    extendedProperties: getActionExtendedProperties(state, { dataSourceKey, actionId }),
});

export const RowAction = connect(mapStateToProps)(RowActionComponent);
